import React, { useContext, useEffect, useState } from "react";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { ContentState, SKVideoArtifact } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";
import VideoInput from "./VideoInput";
import { useNavigate } from "react-router-dom";
import ImageInput from "./ImageInput";
import { FolderName } from "../../../api/shared/uploadService";

const CreateVideo = () => {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable } = useContext(CreateArtifactContext);
  const [videoData, setVideoData] = useState<SKVideoArtifact | undefined | null>(undefined);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  // const [editable, setEditable] = useState<boolean>(true);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Video",
      enableLink:
        contentData.status === ContentState.IN_REVIEW
          ? false
          : videoData?.videoURL && videoData.coverMedia?.coverImageURL
          ? true
          : false
          ? true
          : false,
      getActionItems: undefined,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, videoData, isEditable]);

  const submit = async () => {
    await saveData();
    window.history.back();
  };

  useEffect(() => {
    setVideoData(contentData as SKVideoArtifact);
  }, [contentData]);

  const handleFileChange = (fileUrl: string | null) => {
    if (fileUrl) {
      updateContentData({ videoURL: fileUrl });
    } else {
      setVideoData(null);
      const { videoURL, ...rest } = contentData as SKVideoArtifact;
      updateContentData(rest);
    }
  };
  const handleImageChange = (index: number, fileUrl: string | null) => {
    updateContentData({ coverMedia: { ...contentData.coverMedia, coverImageURL: fileUrl! } });
  };

  return (
    <div className="flex flex-col mt-[12px] gap-[30px]">
      <div>
        <div className="flex flex-col">
          <div className="flex items-center">
            <span>
              <span className="content_count">1</span>
            </span>
            <span className="content_title">Add Video</span>
          </div>
          <div className="notes-class-content">
            Maximum one video of 90 seconds allowed. Use Stories to upload more videos. Recommended aspect ratio of video is either 4:3, 1:1, or 3:4.
          </div>
        </div>
        <div className="flex flex-row gap-x-[15px]">
          {/* {images.map((_, index) => ( */}
          <VideoInput
            docId={artifactId!}
            onFileChange={handleFileChange}
            videoUrl={videoData?.videoURL}
            maxVideoDuration={300}
            maxFileSize={300}
            editable={isEditable}
            folder={FolderName.content}
          />
        </div>
      </div>
      <div>
        <div className="flex flex-col">
          <div className="flex items-center">
            <span>
              <span className="content_count">2</span>
            </span>
            <span className="content_title">Add Video Cover</span>
          </div>
          <div className="notes-class-content">
            Choose a photo that represents the topic, purpose or title of the Video. Recommended aspect ratio of photo is either 4:3, 1:1, or 3:4.
          </div>
        </div>
        <ImageInput
          key={0}
          index={0}
          onFileChange={handleImageChange}
          docId={artifactId!}
          maxFileSize={10}
          imageUrl={videoData?.coverMedia?.coverImageURL}
          editable={isEditable}
          folder={FolderName.content}
        />
      </div>
    </div>
  );
};

export default CreateVideo;
